export default __webpack_public_path__ + "static/media/moneyProphet.56780f25.png";